export default __webpack_public_path__ + "static/media/Property1Character14.08339900.svg";